export const auditTrailTour = {
    module: 'audit_trail',
    title: 'Audit Trail Tour',
    title_vi: 'Tour Nhật ký kiểm toán',
    description: 'As the Internal Audit Lead (P-VN-10), query cross-module evidence, assemble audit packs, and export tamper-evident logs for regulatory submissions.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Internal Audit Lead (P-VN-10), query cross-module evidence, assemble audit packs, and export tamper-evident logs for regulatory submissions.',
    estimated_duration_seconds: 36,
    steps: [
        {
            step_id: 'open_audit',
            navigate_to: '/admin/audit',
            target: '.dm-page',
            title: 'Audit Trail Overview',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Audit Trail Overview',
            description: 'As the Internal Audit Lead, you will use this tamper-evident log to build cross-module evidence packs. Every action across the platform is recorded here for GDPR Article 5(2) accountability.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Internal Audit Lead, you will use this tamper-evident log to build cross-module evidence packs. Every action across the platform is recorded here for GDPR Article 5(2) accountability.',
            position: 'auto',
        },
        {
            step_id: 'audit_list',
            target: '.dm-table',
            title: 'Audit Event List',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Audit Event List',
            description: 'Each row captures the timestamp, actor, action type, and affected entity. Use this to trace who did what and when -- critical for demonstrating accountability during regulatory inspections.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each row captures the timestamp, actor, action type, and affected entity. Use this to trace who did what and when -- critical for demonstrating accountability during regulatory inspections.',
            position: 'auto',
        },
        {
            step_id: 'filter_panel',
            target: '.dm-filters',
            title: 'Filter Panel',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Panel',
            description: 'Narrow events by actor, action type, or module to isolate evidence for a specific audit scope -- for example, all consent changes made by a particular team member.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Narrow events by actor, action type, or module to isolate evidence for a specific audit scope -- for example, all consent changes made by a particular team member.',
            position: 'bottom',
        },
        {
            step_id: 'search_events',
            target: '[data-testid="audit-search"]',
            title: 'Search Audit Events',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search Audit Events',
            description: 'Search by actor name, entity ID, or action description to quickly locate specific evidence records when assembling an audit pack.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search by actor name, entity ID, or action description to quickly locate specific evidence records when assembling an audit pack.',
            position: 'bottom',
        },
        {
            step_id: 'date_range',
            target: '[data-testid="date-range-picker"]',
            title: 'Set Date Range',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set Date Range',
            description: 'Select a date range matching your audit period -- quarterly reviews, annual assessments, or a custom window aligned to the regulatory reporting cycle.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select a date range matching your audit period -- quarterly reviews, annual assessments, or a custom window aligned to the regulatory reporting cycle.',
            position: 'bottom',
        },
        {
            step_id: 'entity_type_filter',
            target: '[data-testid="entity-type-filter"]',
            title: 'Filter by Entity Type',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by Entity Type',
            description: 'Filter by entity type to build module-specific evidence packs -- for example, isolate all incident-related actions or all DPIA approvals for a targeted audit scope.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by entity type to build module-specific evidence packs -- for example, isolate all incident-related actions or all DPIA approvals for a targeted audit scope.',
            position: 'bottom',
            action: { type: 'click', target: '[data-testid="entity-type-filter"]' },
            duration_ms: 100,
        },
        {
            step_id: 'export_audit',
            target: '.page-header .btn-secondary',
            title: 'Export Audit Logs',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export Audit Logs',
            description: 'Export the filtered trail as a CSV or PDF to assemble your audit evidence pack. These exports satisfy GDPR Article 30 record-keeping and can be attached directly to regulatory submissions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export the filtered trail as a CSV or PDF to assemble your audit evidence pack. These exports satisfy GDPR Article 30 record-keeping and can be attached directly to regulatory submissions.',
            position: 'bottom',
        },
        {
            step_id: 'audit_complete',
            target: '.dm-page',
            title: 'Audit Trail Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Audit Trail Tour Complete',
            description: 'You can now query cross-module evidence, assemble audit packs by entity and date range, and export tamper-evident logs that demonstrate accountability to regulators.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now query cross-module evidence, assemble audit packs by entity and date range, and export tamper-evident logs that demonstrate accountability to regulators.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=audit-trail.js.map